
import React, { useState } from 'react';
import { FaPaperPlane } from 'react-icons/fa';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    sede: 'temperley'
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Aquí normalmente se enviaría el formulario a un backend
    // Simulamos una respuesta exitosa
    setFormStatus({
      submitted: true,
      success: true,
      message: '¡Mensaje enviado correctamente! Nos pondremos en contacto contigo pronto.'
    });

    // Resetear el formulario después de enviarlo
    setFormData({
      nombre: '',
      email: '',
      telefono: '',
      mensaje: '',
      sede: 'temperley'
    });
  };

  return (
    <div className="contact-form-container">
      <h2>Contáctanos</h2>
      <p>Completa el siguiente formulario y nos pondremos en contacto contigo a la brevedad.</p>

      {formStatus.submitted && (
        <div className={`form-message ${formStatus.success ? 'success' : 'error'}`}>
          {formStatus.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="nombre">Nombre completo</label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Correo electrónico</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="telefono">Teléfono</label>
          <input
            type="tel"
            id="telefono"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="sede">Sede de interés</label>
          <select
            id="sede"
            name="sede"
            value={formData.sede}
            onChange={handleChange}
          >
            <option value="temperley">Temperley</option>
            <option value="glew">Glew</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="mensaje">Mensaje</label>
          <textarea
            id="mensaje"
            name="mensaje"
            value={formData.mensaje}
            onChange={handleChange}
            rows="5"
            required
          />
        </div>

        <button type="submit" className="submit-button">
          <FaPaperPlane /> Enviar mensaje
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
